import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { environment } from 'environments/environment';
import { AuthService } from 'app/auth/auth.service';
import { CitiesInfo } from '../objects/cities';


@Component({
  selector: 'app-upload-image-modal',
  templateUrl: './upload-image-modal.component.html',
  styleUrls: ['./upload-image-modal.component.scss']
})
export class UploadImageModalComponent implements OnInit {

  public loading: boolean;
  public uploader: FileUploader;
  public hasFile: boolean;
  public data: CitiesInfo = new CitiesInfo;

  @Input() cityId: string = null;
  constructor(
    private auth: AuthService,
    public dialogRef: MatDialogRef<UploadImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() {

    this.startFiles();
  }

  // Files
  fileOverBase(e: any): void {
    this.hasFile = e;
  }

  startFiles() {
    const url = environment.apiURL + '/restricted/cityProfile/uploadImage/' + this.dialogData.cityId;

    this.uploader = new FileUploader({
      url: url,
      autoUpload: true,
      isHTML5: true
    });

    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
      item.headers = [{
        name: 'Authorization',
        value: 'Bearer ' + this.auth.accessToken
      }];
    }

    this.uploader.onProgressAll = () => {
      this.loading = true;
    };

    this.uploader.onCompleteAll = () => {
      this.loading = false;
    };

    this.uploader.onCompleteItem = (item: FileItem, response: any, status: any) => {
      const data = JSON.parse(response);
      this.data.basicInfo.image = data.url;
      item.remove();
      this.dialogRef.close(data);
    };
  }

  hasImage(filename): boolean {
    if (/\.(jpe?g|png|gif|bmp)$/i.test(filename)) {
      return true;
    } else {
      return false;
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
}
